import { useEffect } from "react";
import { Serwist } from "@serwist/window";
import { setupSerwistNavigationCache } from "./serwistNavigationCache.js";
export function setupSerwistUpdates({
  serwist,
  windowRef
}) {
  let activationRequested = false;
  let reloaded = false;
  const onWaiting = () => {
    activationRequested = true;
    serwist.messageSkipWaiting();
  };
  const onControlling = event => {
    if (reloaded || !(activationRequested || event?.isUpdate)) return;
    reloaded = true;
    windowRef.location.reload();
  };
  serwist.addEventListener("waiting", onWaiting);
  serwist.addEventListener("controlling", onControlling);
  return () => {
    serwist.removeEventListener("waiting", onWaiting);
    serwist.removeEventListener("controlling", onControlling);
  };
}
async function cleanDevelopmentWorker() {
  await Promise.all([navigator.serviceWorker.getRegistrations().then(registrations => Promise.all(registrations.map(registration => registration.unregister()))), "caches" in window ? caches.keys().then(keys => Promise.all(keys.map(key => caches.delete(key)))) : Promise.resolve()]);
  if (navigator.serviceWorker.controller && sessionStorage.getItem("catchy_dev_sw_cleanup_reloaded") !== "true") {
    sessionStorage.setItem("catchy_dev_sw_cleanup_reloaded", "true");
    window.location.reload();
  }
}

// One deployment/update policy for every app, called by the shared app shell.
// Build identity and cache behavior cannot drift by region.
export default function useCatchyServiceWorker(router) {
  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;
    if (process.env.NODE_ENV !== "production") {
      void cleanDevelopmentWorker().catch(error => console.error("Service worker cleanup failed:", error));
      return;
    }
    sessionStorage.removeItem("catchy_dev_sw_cleanup_reloaded");
    if (!(window.serwist instanceof Serwist)) {
      window.serwist = new Serwist(`/sw.js?v=${process.env.NEXT_PUBLIC_APP_VERSION}`, {
        scope: "/",
        updateViaCache: "none"
      });
    }
    const cleanupUpdates = setupSerwistUpdates({
      serwist: window.serwist,
      windowRef: window
    });
    const cleanupNavigation = setupSerwistNavigationCache(router, window);
    void window.serwist.register().catch(error => console.error("Service worker registration failed:", error));
    return () => {
      cleanupUpdates();
      cleanupNavigation();
    };
    // The Pages Router event emitter is stable for the app lifetime.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.events]);
}